export default "__VITE_ASSET__DQ4pUm8P__"